import type { ReactNode } from 'react'

interface ClaimStepShellProps {
  /** 1-based step number, shown as "Step N of stepCount". */
  step: number
  /** How many steps the wizard has; the claim's five by default. */
  stepCount?: number
  title: string
  subtitle: ReactNode
  /** Off where the page already says what it is, e.g. a submitted claim beside its timeline. */
  showHeader?: boolean
  children: ReactNode
}

/** Shared wizard-step layout: the centered container + "Step N of M" header. */
export function ClaimStepShell({
  step,
  stepCount = 5,
  title,
  subtitle,
  showHeader = true,
  children,
}: ClaimStepShellProps) {
  return (
    <div className="mx-auto flex w-full max-w-2xl flex-col gap-6 px-4 py-6">
      {showHeader && (
        <div>
          <p className="text-sm font-medium text-orange-500">
            Step {step} of {stepCount}
          </p>
          <h1 className="mt-2 text-2xl font-semibold text-neutral-900">{title}</h1>
          <div className="mt-2 text-sm text-neutral-700">{subtitle}</div>
        </div>
      )}
      {children}
    </div>
  )
}
